import { Outlet } from 'react-router-dom';
import Header from './Header';
import BottomNav from './BottomNav';

export default function AppLayout() {
  return (
    <div className="flex min-h-[var(--litopia-layout-100dvh)] flex-col bg-letter-paper">
      <Header />
      <main id="opp-main-content" className="opp-shell-main opp-shell-horizontal mx-auto w-full max-w-[var(--litopia-layout-1400px)] flex-1 pt-5 sm:pt-6">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
}
